import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { IoMdCloseCircle } from 'react-icons/io';
import { FaCalendarAlt, FaUsers, FaDollarSign, FaTicketAlt, FaCreditCard, FaFileInvoiceDollar, FaBus } from 'react-icons/fa';
import { MdEventSeat } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { invertirFecha, numeroFormateado } from '../../../../tools/utils'
import FormPago from '../../../../Pagar/FormPago';
import { ProductContext } from '../../../../../context/ProductContext';
import PagoExitoso from '../../../../Pagar/pagoExitoso/PagoExitoso';
import PagoFracaso from '../../../../Pagar/pagoFracaso/PagoFracaso';
import toast from 'react-hot-toast';

export default function ReserveCard({ reserva, user }) {

    const { setReserva } = useContext(ProductContext)

    const [traerModal, setTraerModal] = useState(false);
    const [traerModalPagar, setTraerModalPagar] = useState(false);
    const [loading, setLoading] = useState(false)
    const [informacionAgencias, setInformacionAgencias] = useState(null)
    const [montoPagarPayway, setMontoPagarPayway] = useState(0)
    const [montoTipado, setMontoTipado] = useState(0);
    const [datosTarjeta, setDatosTarjeta] = useState({
        totalCuotas: 0,
        tarjetaSeleccionada: {},
        anioExp: 0,
        mesExp: 0,
        numeroTarjeta: 0,
        cvv: 0,
        tipoDocumento: {},
        numeroDocumento: 0,
        titularTarjeta: '',
        bancoSeleccionado: 0,
        tasa: null,
        cantidadCuotas: {}
    })
    const [traerModalExito, setTraerModalExito] = useState(false);
    const [traerModalFracaso, setTraerModalFracaso] = useState(false);

    useEffect (() => {
        const traerDataParaAgencias = async () => {
            const data = {
                 peticion: 7,
                fecha:reserva.evento.fecha,
                idEntidad:user.idEntidadG,
                idProducto:reserva.productoM.idProducto
            }
            //console.log(data)
            try {
                const response = await axios.post('https://www.estanciamargarita.com.ar/backendGama/php/servicios/servicioConvenioG.php', data)
                setInformacionAgencias(response.data)
                   // console.log(response.data)
            } catch (error) {
                console.error(error);
            }
        }
        if(reserva && user && (user.idTipoEntidadG === 3 || user.idTipoEntidadG === "3" || user.idTipoEntidadG === 5 || user.idTipoEntidadG === "5" || user.idTipoEntidad === 4 || user.idTipoEntidad === "4") ) {
            traerDataParaAgencias();
        }
    }, [reserva, user])

    const handleValueModal = (value) => {
        setTraerModal(value)
    }

    const validacionDatos = () => {
                if (!reserva || !reserva.idReserva) {
                    toast.error("No hay reserva seleccionada");
                    return false;
                }

                if (!datosTarjeta.numeroTarjeta || datosTarjeta.numeroTarjeta.toString().length < 12) {
                    toast.error("Número de tarjeta inválido");
                    return false;
                }

                if (!datosTarjeta.mesExp || datosTarjeta.mesExp === 0) {
                    toast.error("Debe ingresar el mes de expiración");
                    return false;
                }

                if (!datosTarjeta.anioExp || datosTarjeta.anioExp === 0) {
                    toast.error("Debe ingresar el año de expiración");
                    return false;
                }

                if (!datosTarjeta.cvv || datosTarjeta.cvv.toString().length < 3) {
                    toast.error("CVV inválido");
                    return false;
                }

                if (!datosTarjeta.titularTarjeta || datosTarjeta.titularTarjeta.trim() === '') {
                    toast.error("Debe ingresar el nombre del titular");
                    return false;
                }

                if (!datosTarjeta.tipoDocumento || !datosTarjeta.tipoDocumento.sigla) {
                    toast.error("Debe seleccionar el tipo de documento");
                    return false;
                }

                if (!datosTarjeta.numeroDocumento || datosTarjeta.numeroDocumento.toString().length < 6) {
                    toast.error("Número de documento inválido");
                    return false;
                }

                if (!datosTarjeta.tarjetaSeleccionada || !datosTarjeta.tarjetaSeleccionada.idCuentaEntidad) {
                    toast.error("Debe seleccionar una tarjeta");
                    return false;
                }

                if (!datosTarjeta.bancoSeleccionado || datosTarjeta.bancoSeleccionado === 0) {
                    toast.error("Debe seleccionar un banco");
                    return false;
                }

                if (!datosTarjeta.cantidadCuotas || !datosTarjeta.cantidadCuotas.cuota) {
                    toast.error("Debe seleccionar la cantidad de cuotas");
                    return false;
                }

                return true;
            };

    const handleAbrirVoucher = (idReserva) => {
        var dat = JSON.stringify(parseInt(idReserva));
        var losDatos = btoa(dat);
        const url = `http://pedrazaviajes.dyndns.org:5555/margaritan/php/dao/printVoucherReserva.php?idfg='+${losDatos}`;

        window.open(url, '_blank');

    }



    const prismaIdMap = {
        25: 1,   // visa
        26: 31,  // visa débito
        29: 65,  // amex
        27: 104, // master crédito
        28: 106, // master débito
        30: 8    // diners
    };
    const prismaId = datosTarjeta.tarjetaSeleccionada.idCuentaEntidad ? prismaIdMap[datosTarjeta.tarjetaSeleccionada.idCuentaEntidad] || null : null;

    const PagarConFirsData = () => {
        // console.log(datosTarjeta);
        // console.log(reserva)

        setLoading(true);
        const fechaActual = new Date();
        const fechaFormateada = fechaActual.toISOString().split('T')[0];

       // const total= reserva.totalReserva;
        const montoPagar = montoTipado !== 0 ? montoTipado : reserva.totalReserva;
        const intereses = (datosTarjeta.tasa / 100) * montoPagar;
       

        const objetoPagar = {
            NRORESERVA: reserva.idReserva,
            den_prodcab: reserva.productoM.denominacion,
            canal: 2,
            cod_cliente: user.idEntidadG,
            intereses: intereses,
            cotizacion: 1,
            cuotas: datosTarjeta.cantidadCuotas.cuota,
            idbcom: datosTarjeta.bancoSeleccionado,
            tasa: datosTarjeta.tasa,
            cod_bcom: datosTarjeta.bancoSeleccionado,
            idtarm: datosTarjeta.tarjetaSeleccionada.idCuentaEntidad,
            totalPagar: montoPagarPayway,
            nombreTarjeta: datosTarjeta.tarjetaSeleccionada.descripcion,
            email: reserva.contactosReserva[1].dato,
            numeroTarjeta: datosTarjeta.numeroTarjeta,
            mesExp: datosTarjeta.mesExp,
            anioExp: datosTarjeta.anioExp,
            cvv: datosTarjeta.cvv,
            tipoDni: {
                siglas: datosTarjeta.tipoDocumento.sigla,
            },
            numeroDoc: datosTarjeta.numeroDocumento,
            prisma: prismaId,
            card_holder_name: datosTarjeta.titularTarjeta
        };

        const data = {
            peticion: 4,
            pagoElectronico: objetoPagar,
        };
      
    
        const url = `https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosGenerales.php`;

        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(response => {
            if (response.data) {
                if(response.data.estado==='error'){
                    setTraerModalFracaso(true)
                } else {
                    setTraerModalExito(true);
                }
            }
        }).catch(error => {
            console.error(error);
        }).finally(() => {
            setLoading(false);
        });
    }

    const handlePagoFracaso = () => {
        window.location.replace("https://estanciamargarita.com.ar/auth/profile");
    }

    if (traerModalExito) {
        return <PagoExitoso />
    }
    if (traerModalFracaso) {
        return <PagoFracaso onClick={() => handlePagoFracaso()} />
    }

    const totalBrutoAgencia = () =>{
       const adultos = Number(reserva.paxMayores);
       const menores = Number(reserva.paxMenores);
       const liberados = Number(reserva.paxLiberados);
       const interes = Number(reserva.totalconceptosAplicadosReserva);

       const totalNeto = ((adultos - liberados) * Number(reserva.productoM.tarifasM.tarifaAdulto )+ menores * Number(reserva.productoM.tarifasM.tarifaMenor)) + interes;
       return totalNeto;
    }
    
    const totalNetoAgencia = () => {
        const adultos = Number(reserva.paxMayores);
        const menores = Number(reserva.paxMenores);
        const liberados = Number(reserva.paxLiberados);

        const totalNeto = (adultos - liberados) * Number(reserva.tarifaBaseAdulto) + menores * Number(reserva.tarifaBaseMenor);
        return totalNeto;
    }
    return (
        <>
            {/* Tarjeta principal con diseño mejorado */}
            <div className="relative overflow-hidden bg-gradient-to-br from-orange-50 via-amber-50 to-amber-100 shadow-2xl rounded-3xl p-4 mt-6 border-2 border-amber-200 hover:shadow-3xl transition-all duration-300 transform hover:-translate-y-1">
                
                {/* Decoración de fondo */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-emerald-200/30 to-teal-200/30 rounded-full -translate-y-16 translate-x-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-cyan-200/30 to-emerald-200/30 rounded-full translate-y-12 -translate-x-12"></div>
                
              

                <div className="flex flex-col xl:flex-row xl:items-start gap-2 relative z-10">
                    
                    {/* Imagen con overlay mejorado */}
                    <div className="relative group">
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent rounded-2xl z-10 group-hover:scale-105 transition-transform duration-300"></div>
                        <img 
                            src='/images/reserva/arbol.jpg' 
                            className='rounded-2xl w-full lg:w-full xl:w-96 h-64 lg:h-24 xl:h-64 object-cover shadow-xl group-hover:scale-105 transition-transform duration-300' 
                            width="1216"
                            height="640" 
                            alt="Reserva"
                        />
                          {/* Badge de estado */}
                <div className="absolute top-4 right-4">
                    <div className={`px-4 py-2 rounded-full text-sm font-bold shadow-lg ${
                        reserva.saldoReserva <= 0 
                            ? 'bg-green-500 text-white' 
                            : 'bg-amber-500 text-white'
                    }`}>
                        {reserva.saldoReserva <= 0 ? '✓ PAGADO' : reserva.totalCobrado > 0 ? '⏳ CONFIRMADO' : '⚠️ PENDIENTE'}
                    </div>
                </div>
                       
                    </div>

                    {/* Información principal */}
                    <div className="flex-1 space-y-6">
                        
                        {/* Header con número de reserva */}
                        <div className="flex bg-white/70 backdrop-blur-sm rounded-2xl p-2 shadow-lg border border-white/50">
                            
                            
                            {/* Fecha del evento */}
                            <div className='flex flex-col sm:flex-row gap-2 items-center'>

                        <div className="flex items-center gap-1 bg-gradient-to-r from-emerald-500 to-teal-300 p-2 rounded-xl">
                                  <FaTicketAlt className="text-white text-xl" />
                                <div>
                                    <p className="text-xs  text-gray-600 font-medium">Reserva</p>
                                    <p className="text-xs tracking-widest font-extrabold text-gray-800 ">
                                        #{reserva.idReserva}
                                    </p>
                                </div>
                            </div>


                            <div className="flex items-center gap-1 bg-gradient-to-r from-emerald-100 to-teal-100 p-2 rounded-xl">
                                <FaCalendarAlt className="text-emerald-600 text-sm" />
                                <div>
                                    <p className="text-xs  text-gray-600 font-medium">Fecha del Evento</p>
                                    <p className="text-xs  font-bold text-gray-800 font-bebas">
                                        {reserva?.evento.fecha ? invertirFecha(reserva.evento.fecha) : reserva.evento.fecha}
                                    </p>
                                </div>
                            </div>
                            {reserva.saldoReserva === reserva.totalReserva && 
                             <div className="flex items-center gap-3 bg-gradient-to-r from-red-100 to-red-200 p-2 rounded-xl">
                                <FaCalendarAlt className="text-emerald-600 text-sm" />
                                <div>
                                    <p className="text-xs  text-gray-600 font-medium">Fecha Vencimiento</p>
                                    <p className="text-xs  font-bold text-gray-800 font-bebas">
                                        {reserva?.fechaVencimiento ? invertirFecha(reserva.fechaVencimiento) : null}
                                    </p>
                                </div>
                            </div>}



                             <div className="flex items-center gap-1 bg-gradient-to-r from-emerald-100 to-teal-100 p-2 rounded-xl">
                                <FaBus className="text-emerald-600 text-sm" />
                                <div>
                                    <p className="text-xs  text-gray-600 font-medium">Producto</p>
                                    <p className="text-xs font-bold text-gray-800 font-bebas">
                                        {reserva?.productoM.idProducto === 3 ? 'Sin Transporte' : 'Con Transporte'}
                                    </p>
                                </div>
                            </div>
                    {informacionAgencias &&
                            <div className="flex items-center gap-1 bg-gradient-to-r from-emerald-100 to-teal-100 p-2 rounded-xl">
                                <FaUsers className="text-emerald-600 text-sm" />
                                <div>
                                    <p className="text-xs text-gray-600 font-medium">Pasajeros</p>
                                    <p className="text-sm font-bold text-gray-800 font-bebas">
                                    {reserva?.paxTotales}
                                    </p>
                                </div>
                            </div>}

                            <div>
                                
 {/* Botones de acción */}
                        <div className="flex justify-center flex-wrap gap-1 ">
                            
                            {/* Ver Pasajeros */}
                            <button 
                                onClick={() => setTraerModal(true)} 
                                className="flex items-center gap-1 px-2 py-3 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
                            >
                                <FaUsers className="text-xs" />
                                Ver Pasajeros
                            </button>

                            {/* Botón Pagar */}
                            {reserva.saldoReserva > 0 && (
                                <button
                                    className="flex items-center gap-1 px-2 py-3 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
                                    onClick={() => {setTraerModalPagar(true); setReserva(reserva);}}
                                >
                                    <FaCreditCard className="text-xs" />
                                    PAGAR AHORA
                                </button>
                            )}

                            {/* Botón Voucher */}
                            {reserva.saldoReserva <= 0 && (
                                <button 
                                    className="flex items-center gap-1 px-2 py-3 bg-gradient-to-r text-sm from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200" 
                                    onClick={() => handleAbrirVoucher(reserva.idReserva)}
                                >
                                    <FaFileInvoiceDollar className="text-xs" />
                                    DESCARGAR VOUCHER
                                </button>
                            )}
                        </div>

                            </div>
                            </div>
                            
                        </div>

                        {/* Información financiera */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                            
                            {/* Total */}
                            <div className="bg-gradient-to-br from-blue-50 to-indigo-100 p-1 rounded-xl border border-blue-200 shadow-md">
                                <div className="flex items-center gap-3">
                                    <div className="bg-blue-500 p-2 rounded-lg">
                                        <FaDollarSign className="text-white" />
                                    </div>
                                    <div>
                                        <p className="text-lg text-gray-600 font-medium">
                                            Total {user.idTipoEntidadG === '3' ? `Neto` : user.idTipoEntidadG === '5' ? `Neto` : user.idTipoEntidad === 4 ? `Neto` : `Reserva`}
                                        </p>
                                        <p className="text-lg font-bold text-blue-700 font-bebas">
                                            {user.idTipoEntidadG==='3' ? numeroFormateado(reserva.totalReserva) :`$${numeroFormateado(reserva.totalReserva)}`}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Total Agencia (si aplica) */}
                            {informacionAgencias && (
                                <div className="bg-gradient-to-br from-purple-50 to-violet-100 p-1 rounded-xl border border-purple-200 shadow-md">
                                    <div className="flex items-center gap-3">
                                        <div className="bg-purple-500 p-2 rounded-lg">
                                            <FaFileInvoiceDollar className="text-white" />
                                        </div>
                                        <div>
                                            <p className="text-lg text-gray-600 font-medium">Total Publico</p>
                                            <p className="text-lg font-bold text-purple-700 font-bebas">
                                                ${numeroFormateado(totalBrutoAgencia())}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Total Cobrado */}
                            <div className="bg-gradient-to-br from-green-50 to-emerald-100 p-2 rounded-xl border border-green-200 shadow-md">
                                <div className="flex items-center gap-3">
                                    <div className="bg-green-500 p-2 rounded-lg">
                                        <FaCreditCard className="text-white" />
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600 font-medium">Total Cobrado</p>
                                        <p className="text-lg font-bold text-green-700 font-bebas">
                                            ${numeroFormateado(reserva.totalCobrado)}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Saldo */}
                            <div className={`bg-gradient-to-br p-2 rounded-xl border shadow-md ${
                                reserva.saldoReserva > 0 
                                    ? 'from-red-50 to-rose-100 border-red-200' 
                                    : 'from-green-50 to-emerald-100 border-green-200'
                            }`}>
                                <div className="flex items-center gap-3">
                                    <div className={`p-2 rounded-lg ${
                                        reserva.saldoReserva > 0 ? 'bg-red-500' : 'bg-green-500'
                                    }`}>
                                        <FaDollarSign className="text-white" />
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-600 font-medium">Saldo</p>
                                        <p className={`text-lg font-bold font-bebas ${
                                            reserva.saldoReserva > 0 ? 'text-red-700' : 'text-green-700'
                                        }`}>
                                            ${numeroFormateado(reserva.saldoReserva)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                       
                    </div>
                </div>
            </div>

            {/* Modal de Pasajeros mejorado */}
            {traerModal && (
                <ModalPasajeros pasajeros={reserva.listaPasajeros} onValueModal={handleValueModal} />
            )}

            {/* Modal de Pago */}
            {traerModalPagar && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-auto">
                        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 rounded-t-2xl">
                            <div className="flex justify-between items-center">
                                <h3 className="text-lg font-bold text-gray-800">Procesar Pago</h3>
                                <button 
                                    onClick={() => setTraerModalPagar(false)} 
                                    className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                                >
                                    <IoMdCloseCircle className="text-lg text-gray-500" />
                                </button>
                            </div>
                        </div>
                        
                        <div className="p-6">
                            <FormPago
                                onClickTotalCuotas={(e) => setDatosTarjeta(prev => ({ ...prev, totalCuotas: e }))}
                                onTarjetaSeleccionada={(e) => setDatosTarjeta(prev => ({ ...prev, tarjetaSeleccionada: e }))}
                                onAnioExp={(e) => setDatosTarjeta(prev => ({ ...prev, anioExp: e }))}
                                onMesExp={(e) => setDatosTarjeta(prev => ({ ...prev, mesExp: e }))}
                                onNumeroTarjeta={(e) => setDatosTarjeta(prev => ({ ...prev, numeroTarjeta: e }))}
                                onCvv={(e) => setDatosTarjeta(prev => ({ ...prev, cvv: e }))}
                                onTipoDocumento={(e) => setDatosTarjeta(prev => ({ ...prev, tipoDocumento: e }))}
                                onNumeroDocumento={(e) => setDatosTarjeta(prev => ({ ...prev, numeroDocumento: e }))}
                                onTitularTarjeta={(e) => setDatosTarjeta(prev => ({ ...prev, titularTarjeta: e }))}
                                onBancoSeleccionado={(e) => setDatosTarjeta(prev => ({ ...prev, bancoSeleccionado: e }))}
                                onTasa={(e) => setDatosTarjeta(prev => ({ ...prev, tasa: e }))}
                                onCantidadCuotas={(e) => setDatosTarjeta(prev => ({ ...prev, cantidadCuotas: e }))}
                                permitirTiparMontos={true}
                                onMontoTipado={(e) => setMontoTipado(e)}
                                onMontoTotalPayway={(e)=> setMontoPagarPayway(e)}
                            />
                            
                            <div className="flex justify-center mt-8">
                                <Link
                                    onClick={(e) => {
                                        if (loading) {
                                            e.preventDefault();
                                        } else {
                                            if (validacionDatos()) {
                                                PagarConFirsData();
                                            }
                                        }
                                    }}
                                    className={`flex items-center gap-3 px-8 py-4 rounded-xl text-white font-bold text-sm shadow-lg transition-all duration-200 ${
                                        loading 
                                            ? 'bg-gray-400 cursor-not-allowed' 
                                            : 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 hover:shadow-xl transform hover:-translate-y-0.5'
                                    }`}
                                >
                                    {loading ? (
                                        <>
                                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                                            Procesando...
                                        </>
                                    ) : (
                                        <>
                                            <FaCreditCard className="text-xl" />
                                            CONFIRMAR PAGO
                                        </>
                                    )}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

// Modal de Pasajeros mejorado
const ModalPasajeros = ({ pasajeros, onValueModal }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden">
                
                {/* Header del modal */}
                <div className="bg-gradient-to-r from-amber-600 to-orange-600 text-white p-6">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-3">
                            <div className="bg-white/20 p-2 rounded-lg">
                                <FaUsers className="text-xl" />
                            </div>
                            <div>
                                <h3 className="text-lg font-bold">Lista de Pasajeros</h3>
                                <p className="text-emerald-100">Total: {pasajeros.length} pasajeros</p>
                            </div>
                        </div>
                        <button 
                            onClick={() => onValueModal(false)} 
                            className="p-2 hover:bg-white/20 rounded-full transition-colors"
                        >
                            <IoMdCloseCircle className="text-lg" />
                        </button>
                    </div>
                </div>

                {/* Contenido de la tabla */}
                <div className="overflow-auto max-h-[calc(90vh-120px)]">
                    <div className="bg-white">
                        <table className="w-full">
                            <thead className="bg-gray-50 sticky top-0">
                                <tr>
                                    <th className="px-6 py-4 text-left text-sm font-bold text-gray-700 uppercase tracking-wider border-b">
                                        <div className="flex items-center gap-2">
                                            <MdEventSeat className="text-emerald-600" />
                                            Nombre
                                        </div>
                                    </th>
                                    <th className="px-6 py-4 text-left text-sm font-bold text-gray-700 uppercase tracking-wider border-b">
                                        Apellido
                                    </th>
                                    <th className="px-6 py-4 text-left text-sm font-bold text-gray-700 uppercase tracking-wider border-b">
                                        <div className="flex items-center gap-2">
                                            <FaCalendarAlt className="text-emerald-600" />
                                            P. Embarque
                                        </div>
                                    </th>
                                    <th className="px-6 py-4 text-left text-sm font-bold text-gray-700 uppercase tracking-wider border-b">
                                        Horario
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {pasajeros.map((pasajero, index) => (
                                    <tr key={index} className="hover:bg-gray-50 transition-colors">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="flex items-center gap-3">
                                                <div className="bg-emerald-100 text-emerald-700 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                                                    {index + 1}
                                                </div>
                                                <span className="font-medium text-gray-900">{pasajero.nombre}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-gray-700 font-medium">
                                            {pasajero.apellido}
                                        </td>
                                        <td className="px-6 py-4 text-gray-600">
                                            <div className="max-w-xs">
                                                {pasajero.direccionFull}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                                                {pasajero.fechaHoraEmbarque}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}